import React, { useEffect, useState } from 'react'
import MaximsPage from './Maxims'
import ConverseValuesPage from './ConverseValues'
import './AboutPage.css'
import nikeSwoosh from '../../images/NikeSwoosh.svg'
import converseLogo from '../../images/converseLogo.svg'

const About = (props) => {
	const [showMaxims, setShowMaxims] = useState(() => {
		if (!props.user) return true

		return props.user.company.includes('NIKE')
	})

	const handleToggle = (isToggle) => {
		if (isToggle !== showMaxims) {
			console.log('toggle')
			setShowMaxims(isToggle)
		}
	}

	console.log('Current Status of showMaxims: ', showMaxims)

	return (
		<div className='about-wrapper'>
			<div className='section-black ncss-row'>
				<div className='about-nav'>
					<a
						style={{ borderBottom: showMaxims ? '1px solid white' : '', height: '75px' }}
						title='About Maxims'
						onClick={() => handleToggle(true)}
						href={`${window.location.origin}/about#maxims`}
					>
						<img
							src={nikeSwoosh}
							alt='Nike Logo'
							style={{
								width: '48px',
								height: '17px',
								marginTop: '4px',
								marginRight: '8px',
							}}
						/>
						Maxims
					</a>
					<a
						style={{ borderBottom: !showMaxims ? '1px solid white' : '', height: '75px' }}
						title='Converse Values'
						onClick={() => handleToggle(false)}
						role='button'
					>
						<img
							src={converseLogo}
							alt='Converse Logo'
							style={{
								width: '40px',
								height: '34px',
								marginTop: '4px',
								marginRight: '8px',
							}}
						/>
						Values
					</a>
				</div>
			</div>
			{showMaxims ? <MaximsPage status={showMaxims} /> : <ConverseValuesPage status={showMaxims} />}
		</div>
	)
}

export default About



// WEBPACK FOOTER //
// ./src/containers/AboutPage/About.js